export enum AstroTime {
    Sunrise = "sunrise",
    SolarNoon = "solarNoon",
    Sunset = "sunset",
    SunriseEnd = "sunriseEnd",
    GoldenHourEnd = "goldenHourEnd",
    GoldenHour = "goldenHour",
    SunsetStart = "sunsetStart",
    Dusk = "dusk",
    NauticalDusk = "nauticalDusk",
    Night = "night",
    Nadir = "nadir",
    NightEnd = "nightEnd",
    NauticalDawn = "nauticalDawn",
    Dawn = "dawn",
}
